import {
  lazy,
  Suspense,
} from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom';

import {
  useTitle,
  LoadingGate,
  PaxityProgress,
} from './components';
import LegalAcceptanceGate from './components/LegalAcceptanceGate';
import RecoveryCodeUsedNotice from './components/secondFactor/RecoveryCodeUsedNotice';
import AuthProvider from './stores/auth/AuthProvider';
import CommsProvider from './stores/comms/CommsProvider';
import HelpProvider from './stores/help/HelpProvider';
import PushProvider from './stores/push/PushProvider';
import QrsProvider from './stores/qrs/QrsProvider';
import StatsProvider from './stores/stats/StatsProvider';
import TownAssetsProvider from './stores/townAssets/TownAssetsProvider';
import TownConfigProvider from './stores/townConfig/TownConfigProvider';
import TutorialProvider from './stores/tutorial/TutorialProvider';
import { config } from './utils';
import DashboardWrapped from './views/Dashboard/DashboardWrapped';
import LoginSwitch from './views/Login/LoginSwitch';

// Lazy load demo components (only used in dev/demo environments)
const DemoWrapped = lazy(() => import('./views/Demo/DemoWrapped'));

function MainLoggedIn() {
  useTitle('Paxity');

  // Provider hierarchy:
  // - AuthProvider, TownConfigProvider, TownAssetsProvider register loaders at module load
  // - They mount immediately and start loading resources in parallel
  // - LoadingGate shows progress until all loaders complete
  // - LoginSwitch handles auth redirect (logged out → login page)
  // - LoadingGate blocks UI until all resources are ready
  return (
    <StatsProvider>
      <HelpProvider>
        <AuthProvider>
          <PushProvider>
            <TownConfigProvider>
              <TownAssetsProvider>
                <LoginSwitch>
                  <LoadingGate debug={config.dev}>
                    <LegalAcceptanceGate>
                      <QrsProvider>
                        <CommsProvider>
                          <TutorialProvider>

                            <Suspense fallback={<PaxityProgress withDiv />}>
                              <Routes>
                                {(config.dev || config.demo)
                                  ? (
                                      <Route
                                        path="/demo"
                                        element={<DemoWrapped />}
                                      />
                                    )
                                  : null}

                                <Route
                                  path="*"
                                  element={<DashboardWrapped />}
                                />
                              </Routes>
                            </Suspense>

                            <RecoveryCodeUsedNotice />

                          </TutorialProvider>
                        </CommsProvider>
                      </QrsProvider>
                    </LegalAcceptanceGate>
                  </LoadingGate>
                </LoginSwitch>
              </TownAssetsProvider>
            </TownConfigProvider>
          </PushProvider>
        </AuthProvider>
      </HelpProvider>
    </StatsProvider>
  );
}

export default MainLoggedIn;
